export default function select(elem) {
    elem.select();
/*
    CHE: disable for now - the select works on IOS but causes it to set handles and popupmenu

    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {

        // save current contentEditable/readOnly status
        const readOnly = elem.readOnly;

        // convert to editable with readonly to stop iOS keyboard opening
        elem.readOnly = true;

        // create a selectable range
        const range = document.createRange();
        range.selectNodeContents(elem);

        // select the range
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        elem.setSelectionRange(0, 999999);

        // restore contentEditable/readOnly to original state
        elem.readOnly = readOnly;

    } else {
        elem.select();
    }
*/
}
